import { AlertService } from '@aurelia-toolkit/alert';
import { GridApi } from 'ag-grid-community';
import { PLATFORM } from 'aurelia-pal';
import { bindable, customElement, useView } from 'aurelia-templating';
import { AggregatedFieldsDialog, IAggregatedFieldsDialogData } from './aggregated-fields-dialog/aggregated-fields-dialog';

export interface IAggregatedField {
  name: string;
  header: string;
  show: boolean;
  defaultShow: boolean;
  value?: number;
}

export interface IOverviewAggregationComponentState {
  fields: IAggregatedField[];
  allowSelection: boolean;
}


@useView(PLATFORM.moduleName('./overview-aggregation-component.html'))
@customElement('overview-aggregation-component')
export class OverviewAggregationComponent {
  constructor(private element: Element, private alertService: AlertService) { }

  @bindable
  params: { api: GridApi; state: IOverviewAggregationComponentState };

  public attached() {
    this.params.api.addEventListener('modelUpdated', this.onGridDataChanged);
  }

  detached() {
    this.params.api.removeEventListener('modelUpdated', this.onGridDataChanged);
  }

  onGridDataChanged = () => {
    this.params.state.fields.forEach(x => {
      x.value = 0;
    });
    this.params.api.forEachNodeAfterFilterAndSort(row => {
      this.params.state.fields.forEach(x => {
        x.value += typeof row.data[x.name] === 'number' ? row.data[x.name] : 0;
      });
    });
  };

  async selectFields() {
    const model: IAggregatedFieldsDialogData = { fields: this.params.state.fields.map(x => ({ ...x })), apply: fields => this.applyFields(fields) };
    await this.alertService.open({ viewModel: AggregatedFieldsDialog, model });
  }

  applyFields(fields: IAggregatedField[]) {
    fields.forEach((x, i) => {
      this.params.state.fields[i].show = x.show;
    });
    this.element.dispatchEvent(new CustomEvent('aggregated-fields-changed', { detail: this.params.state.fields, bubbles: true }));
  }
}
